module.exports = __webpack_public_path__ + "img/sw-ys31.a7fed156.jpg";